const highlightText = (searchWord: string): void => {
  const pdfPages = document.getElementsByClassName('react-pdf__Page__textContent');
  const regex = new RegExp(searchWord, 'ig');

  for (let i = 0; i < pdfPages.length; i++) {
    ['span', 'div'].forEach((type) => {
      pdfPages[i].querySelectorAll(type).forEach((element) => {
        if (element.innerHTML?.includes('<span class="highlight">')) {
          element.innerHTML = element.innerHTML.replace(/<span class="highlight">/g, '');
          element.innerHTML = element.innerHTML.replace(/<\/span>/g, '');
        }
        if (searchWord.length > 1 && element.innerHTML?.toLowerCase().includes(searchWord.toLowerCase())) {
          const initIndex = element.innerHTML.search(regex);
          const lastIndex = initIndex + searchWord.length;
          element.innerHTML = element.innerHTML.replace(
            regex,
            `<span class="highlight">${element.innerHTML.substring(initIndex, lastIndex)}</span>`,
          );
        }
      });
    });
  }
  if (document.getElementsByClassName('highlight').length > 0) {
    document.getElementsByClassName('highlight')[0].scrollIntoView();
  }
};

export default highlightText;
